import { Helmet } from "react-helmet";
import Section1 from "../components/Home/Section1";
import Navbar from "../components/Navbar";
import { lazy, Suspense } from "react";
const Footer = lazy(() => import("../components/Footer"));
const Acheivement = lazy(() => import("../components/Home/Acheivement"));
const CaseStudies = lazy(() => import("../components/Home/CaseStudies"));
const CounterSection = lazy(() => import("../components/Home/CounterSection"));
const Industries = lazy(() => import("../components/Home/Industries"));
const MobileServicesSection = lazy(() => import("../components/Home/MobileServicesSection"));
const OurTeams = lazy(() => import("../components/Home/OurTeams"));
const RequestServices = lazy(() => import("../components/Home/RequestServices"));
const ServicesTabs = lazy(() => import("../components/Home/ServicesTabs"));
const Testimonials = lazy(() => import("../components/Home/Testimonials"));
const RecentBlogs = lazy(() => import("../components/Home/RecentBlogs"));

function Home() {
  
  return (
    <div>
      <Helmet>
        <title>Webinventix | Website Design Services</title>
        <meta
          name="description"
          content="Web Inventix provides world-class web development, web design, and IT services. Let's build something amazing together."
        />
        <meta
          property="og:title"
          content="Web Inventix | web Development"
        />
        <meta
          property="og:description"
          content="Grow your business with our expert mobile and web solutions."
        />
        <meta
          property="og:image"
          content="https://webinventix.com/your-banner-image.jpg"
        />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:url" content="https://webinventix.com/" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Navbar />
      <div className="undefined relative z-50 ">
        <main style={{position: "relative"}}>
          <Section1 />
           <Suspense fallback={<div>Loading...</div>}>
            <CounterSection />
            <MobileServicesSection />
            <RequestServices />
            <CaseStudies />
            <Acheivement />
            <ServicesTabs />
            <Industries />
            <Testimonials />
            <OurTeams />
            <RecentBlogs />
            <Footer />
          </Suspense>
         <a href="tel:+16467607313" className="callbtn">Talk To An Expert</a>
        </main>
        {/* <Footer /> */}
      </div>
    </div>
  );
}

export default Home;
